import React, { useEffect, useRef, useState } from "react";
import FlexCard from "../Helpers/FlexCard";
import { Link } from "react-router-dom";
import IncomeDetailsModal from "./IncomeDetailsModal";
import { Button, Form, Modal } from "react-bootstrap";
import ReferrenceDetailsModal from "./ReferrenceDetailsModal";
import BankingConsentModal from "./BankingConsentModal";
import swal2 from "sweetalert2";

const IncomeDetails = (props) => {
  var isReadonly = props.urlparams.params.readonly === "true" ? true : false;
  const isCpa = props?.$store?.persona === _enum.ROUTE_PERSONAS.cpa;
  var tabStatus = props.urlparams.params.status;
  const frompath = props?.urlparams?.params?.frompath;
  var BASE_URL = `${endpoints[environment].api_base}/api/v1/files/download/`;
  const [uwInfo, setUwInfo] = useState({});
  const [incomedetails, setIncomedetails] = useState({});
  const [bsaReportURL, setBsaReportURL] = useState(null);
  const [bsaReportData, setBsaReportData] = useState(null);
  const [bsaData, setBsaData] = useState(null);
  const [bsaPolling, setBsaPolling] = useState(false);
  const [bsaStatusMessage, setBsaStatusMessage] = useState("");
  const [bsaRetryCooldown, setBsaRetryCooldown] = useState(0);
  const bsaCooldownTimerRef = useRef(null);
  const bsaPollIntervalRef = useRef(null);
  const hasFetchedReportRef = useRef(false);
  const [summaryScoreData, setSummaryScoreData] = useState(null);
  const [creditsData, setCreditsData] = useState(null);
  const [show, setShow] = useState(false);
  const [payslipfiles, setPayslipfiles] = useState([]);
  const [bankStatementFiles, setBankStatementFiles] = useState([]);
  const [passcheck, setPasscheck] = useState(false);
  const [defaultCompanies, setDefaultCompanies] = useState([]);
  const [additionalDocs, setAdditionalDocs] = useState([]);
  const [sanctioneddocs, setSanctioneddocs] = useState([]);
  const [referenceData, setReferenceData] = useState({});
  const [salaryCreditsData, setSalaryCreditsData] = useState([]);
  const [infoModalType, setInfoModalType] = useState("");
  const additionalDocForm = useRef(null);
  const incomeDetailsForm = useRef(null);
  const pollIntervalRef = useRef(null);
  const popupRef = useRef(null);
  const [isPolling, setIsPolling] = useState(false);

  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [bsaTableData, setBsaTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [bsaRowcount, setBsaRowcount] = useState(0);
  const bsaColumns = [
    {
      dataIndex: "bankname",
      title: "Bank Name",
    },
    {
      dataIndex: "statementUploaded",
      title: "Statement Uploaded",
      render: (text, record) => {
        if (record?.fileId) {
          return (
            <div>
              <a href={`${BASE_URL}${record?.fileId}`} className="text-primary">
                Download
              </a>
            </div>
          );
        } else {
          return <>-</>;
        }
      },
    },
    {
      dataIndex: "filePassword",
      title: "File Password",
      render: (text, record) => {
        return <>{text || "-"}</>;
      },
    },
    {
      dataIndex: "startDate",
      title: "From Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        if (record?.startDate) {
          return date;
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "endDate",
      title: "To Date",
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        if (record?.endDate) {
          return date;
        } else {
          return "-";
        }
      },
    },
  ];
  const [consentData, setConsentData] = useState({
    consentId1: "",
    consentId2: "",
    consentId3: "",
    pdf: "",
    pdfName: "",
  });
  const payslipFields = [
    {
      name: "payslipDate",
      label: "Select Month",
      type: "month",
    },
    {
      name: "fileId",
      label: "Upload",
      type: "file",
      accept: ".pdf",
      fileLabel: "Upload pdf",
      accept: "application/pdf",
      foldername: "payslipDocs",
    },
  ];

  const handleShow = (e) => {
    setShow(true);
  };

  const handleClose = (e) => {
    setPasscheck(false);
    setShow(false);
  };

  const handlePasswordCheck = (e) => {
    let value = e.target.checked;
    setPasscheck(value);
  };

  const deleteField = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    let data = [...payslipfiles];
    data.splice(index, 1);
    console.log({ index, data });
    setPayslipfiles(data);
  };

  const handlePayslipSubmit = (e, data) => {
    let paydate = new Date(data?.payslipDate);
    let payslipDate = new Date(paydate);
    payslipDate.setMonth(payslipDate.getMonth() + 1);

    let payload = {
      ...data,
      payslipDate: new Date(payslipDate).toISOString(),
    };
    console.log({ data, payload });

    let mokeData = [
      {
        payslipDate: "2024-03-01T00:00:00.000Z",
        fileId: "9c08b7cf-ff3f-4904-a6c3-202124d2e561",
        filename: "Month 4 - Pay Slip",
        filePassword: null,
      },
    ];
    setPayslipfiles((prevState) => [...prevState, ...mokeData]);
    handleClose();
  };
  // ----------------------------------------------------------------

  const [modalFields, setModalFields] = useState([
    {
      name: "companyname",
      label: "Company Name",
      type: "select",
      options: [],
      searchFn: (value) => handleCompanyNameSearch(value),
      onChange: (...args) => handleCompanyChange(...args),
    },
    {
      name: "newcompanyname",
      label: "New Company Name",
      type: "text",
      placeholder: "Please enter",
      disabled: true,
    },
    {
      name: "salaryMode",
      label: "Mode of Salary",
      type: "select",
      options: _enum.MODE_OF_SALARY,
    },
    {
      name: "monthlySalary",
      label: "Monthly Gross Salary",
      type: "number",
    },
    {
      name: "officialEmail",
      label: "Office Email ID",
      type: "text",
      hasVerifyBtn: true,
      hasVerifyBadge: true,
      onVerifyBtnClick: (...args) => handleVerifyBtnClick(...args),
    },
    {
      name: "companyCategory",
      label: "Company category",
      type: "select",
      options: _enum.COMPANY_CATEGORY,
    },
    {
      name: "natureOfBusiness",
      label: "Company Nature of business",
      type: "select",
      options: _enum.COMPANY_NATURE_OF_BUSINESS,
    },
    {
      name: "applicantJobProfile",
      label: "Applicant's Designation",
      type: "text",
    },
    {
      name: "doj",
      label: "DOJ",
      type: "date",
    },
    {
      name: "pfDeducted",
      label: "PF/Others Deducted ",
      type: "select",
      onChange: (...args) => handlePfDeducted(...args),
      options: _enum.YES_OR_NO_BOOLEAN,
    },
    {
      name: "pfAmountDeducted",
      label: "PF/Others Amount Deducted ",
      type: "number",
    },
    {
      name: "monthlyNetTakeSalary",
      label: "Monthly Net Take Salary ",
      type: "number",
    },
    {
      name: "bankName",
      label: "Bank Name (as per Pay Slip)",
      type: "text",
    },
    {
      name: "finalNetSalary",
      label: "Final Net Salary",
      type: "number",
    },
    {
      name: "salaryCreditDate",
      label: "Salary Credit Date",
      type: "date",
    },
    {
      name: "avgMonthlyBalance",
      label: "Avg. Monthly Balance",
      type: "number",
    },
    {
      name: "remarks",
      label: "Remarks",
      type: "text",
      customcolspan: 12,
    },
  ]);
  const [editData, setEditData] = useState([]);
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});
  const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });

  const openModal = (modalname) => {
    setOpenCanvas(true);
    addModalFields(modalname);
    setInfoModalType(modalname);
  };

  const closeModal = () => {
    setOpenCanvas(false);
  };

  const onModalClose = () => {
    console.log("onModalClose");
    closeModal();
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
    setErrorMessage({ name: "", message: "" });
  };

  const addModalFields = (modalname) => {
    let fields;
    if (modalname === "companyModal") {
      fields = (modalFields || []).reduce(
        (o, n) => ({ ...o, [n.name]: n }),
        {}
      );
    }
    if (modalname === "bankAccountModal") {
      fields = (bankAccountFields || []).reduce(
        (o, n) => ({ ...o, [n.name]: n }),
        {}
      );
    }

    let formdata = Object.map(fields, (v, k) => "");
    setPopupfields(fields);
    setPopupdata(formdata);
    setOpenCanvas(true);
  };

  const editSalaryInfo = (e, record) => {
    setEditmode(true);
    setViewmode(false);

    console.log({ record });

    let filteredData = Object.only(
      record,
      modalFields.map((v) => v.name)
    );
    console.log({ record, filteredData });

    setPopupdata(filteredData);
    setEditData(record);
    let updatedFields = modalFields?.map((field) => {
      if (field.name === "pfAmountDeducted") {
        if (filteredData?.pfDeducted === false) {
          return {
            ...field,
            defaultValue: "",
            disabled: true,
          };
        } else {
          return {
            ...field,
            defaultValue: filteredData[field?.name],
          };
        }
      }
      if (field.name === "companyname" || field.name === "salaryMode") {
        if (
          !field.options.find(
            (option) => option.key === filteredData[field?.name]
          )
        ) {
          field.options = [
            ...field.options,
            {
              key: filteredData[field?.name] || "",
              label: filteredData[field?.name] || "",
            },
          ];
        }
        return {
          ...field,
          defaultValue: filteredData[field?.name] || "",
          // disabled: true,
        };
      }
      if (field.name === "officialEmail") {
        return {
          ...field,
          id: uwInfo?.customerId,
          defaultValue: filteredData[field?.name],
        };
      }
      return {
        ...field,
        defaultValue: filteredData[field?.name],
      };
    });
    setModalFields([...updatedFields]);
    openModal("companyModal");
    setTimeout(() => {
      if (record?.officialEmailVerification === true) {
        document
          .querySelector("[name='appinput-officialEmail'] .verify_btn")
          .classList.add("d-none");
        document
          .querySelector(
            "[name='appinput-officialEmail'] .floating_verified_badge"
          )
          .classList.remove("d-none");
      } else {
        document
          .querySelector("[name='appinput-officialEmail'] .verify_btn")
          .classList.remove("d-none");
        document
          .querySelector(
            "[name='appinput-officialEmail'] .floating_verified_badge"
          )
          .classList.add("d-none");
      }
    }, 500);
  };

  useEffect(() => {
    // console.log({ popupfields });

    // let companyNameInput = document.querySelector(
    //   "[name='appinput-companyname'].form-group"
    // );
    // console.log(companyNameInput);

    let filteredData = Object.only(
      editData,
      modalFields.map((v) => v.name)
    );
    let updatedFields = modalFields?.map((field) => {
      if (field.name === "companyname") {
        let companyNameInput = document.querySelector(
          "[name='appinput-companyname'].form-group"
        );
        if (companyNameInput) {
          let companySelect = companyNameInput?.vnode.refs.select;
          // console.log(popupdata, companyNameInput, companySelect);

          if (companySelect && companySelect?.state?.values?.length === 0) {
            let value = filteredData[field.name];
            let payload = {
              companyName: value,
            };
            if (value?.length >= 3) {
              props.apis.apiGetMasterCompanies(payload).then(({ data }) => {
                if (data) {
                  let companyNameInput = document.querySelector(
                    "[name='appinput-companyname'].form-group"
                  );
                  let companySelect = companyNameInput.vnode.refs.select;
                  let { searchResults } = companySelect.state;
                  let datawithkey = data?.options("companyName");
                  // console.log({ searchResults, datawithkey });
                  searchResults = datawithkey;

                  companySelect.setState(
                    {
                      searchResults,
                      values: datawithkey,
                    },
                    () => {
                      // reset search results with default company names
                      companySelect.setState({
                        searchResults: defaultCompanies.options("companyName"),
                        values: datawithkey,
                      });
                    }
                  );
                }
              });
            }
          }
        }
      }
      return {
        ...field,
        defaultValue: filteredData[field?.name],
      };
    });
    setModalFields([...updatedFields]);
  }, [popupfields]);

  useEffect(() => {
    let fields;
    if (infoModalType === "bankAccountModal") {
      fields = (bankAccountFields || []).reduce(
        (o, n) => ({ ...o, [n.name]: n }),
        {}
      );
    } else {
      fields = (modalFields || []).reduce(
        (o, n) => ({ ...o, [n.name]: n }),
        {}
      );
    }
    // console.log({ updatedfields: fields });
    setPopupfields(fields);
  }, [editData]);

  const handleCompanyNameSearch = (params) => {
    let selectedVal = params.state.values[0];
    console.log({ params, selectedVal });

    let value = params?.state?.search;
    let payload = {
      companyName: value,
    };
    if (value?.length >= 3) {
      mixins.debounce(() => {
        props.apis.apiGetMasterCompanies(payload).then(({ data }) => {
          if (data) {
            let companyNameInput = document.querySelector(
              "[name='appinput-companyname'].form-group"
            );
            let companySelect = companyNameInput.vnode.refs.select;
            let { searchResults } = companySelect.state;
            let datawithkey = data?.options("companyName");
            console.log({ searchResults, datawithkey });
            searchResults = datawithkey;

            if (searchResults.length === 0) {
              companySelect.setState({
                searchResults: [{ key: "OTHERS", label: "Others" }],
              });
            } else {
              companySelect.setState({ searchResults });
            }
          }
        });
      }, 1000);
    }
  };

  const handleCompanyChange = (value) => {
    let key = value[0]?.key;
    console.log({ key });

    var newCompanyNameInput = document.querySelector("[name='newcompanyname']");
    if (key === "OTHERS") {
      newCompanyNameInput.disabled = false;
    } else {
      newCompanyNameInput.disabled = true;
      newCompanyNameInput.value = "";
      newCompanyNameInput.defaultValue = "";
    }
  };

  const handlePfDeducted = (val) => {
    let value = val[0]?.key;
    // console.log({ value });
    let input = document.querySelector('[name="pfAmountDeducted"]');
    if (value === false) {
      input.disabled = true;
      input.value = 0;
    } else {
      console.log(editData);
      input.disabled = false;
      input.value = "";
      // input.value = editData?.pfAmountDeducted;
      // input.defaultValue = editData?.pfAmountDeducted;
    }
  };

  const handleVerifyBtnClick = (value) => {
    let customerId = document.querySelector('[name="officialEmail"]')?.id;
    let urldata = {
      email: value,
      customerId: Number(customerId) || "",
    };

    console.log({ urldata });

    const resolve = () => {
      const targetTime = new Date().getTime() + 10000; // 2 minutes from now
      localStorage.setItem("officeEmailVerifyTimer", targetTime);
      document.querySelector(
        "[name='appinput-officialEmail'] .verify_btn"
      ).disabled = true;

      const timer = setTimeout(() => {
        document.querySelector(
          "[name='appinput-officialEmail'] .verify_btn"
        ).disabled = false;
        localStorage.removeItem("officeEmailVerifyTimer");
      }, 10000);

      swal2.fire({
        text: "Email verification send to your email ID. Please check your registered Email ID to verify it.",
        icon: "success",
        timer: 4000,
        iconColor: "#FF4D4D",
        confirmButtonText: "Ok",
        showCancelButton: false,
      });
      return () => clearTimeout(timer);
    };

    props.apis.apiCustomerGenerateOfficialEmail(urldata).then((res) => {
      resolve();
    });
  };

  const getCompanies = () => {
    props.apis.apiGetMasterCompanies().then(({ data }) => {
      // console.log({ data });
      if (data) {
        setDefaultCompanies(data);
        let companyNameField = modalFields.find(
          (field) => field.name === "companyname"
        );
        companyNameField.options = data.options("companyName");
        setModalFields([...modalFields]);
      }
    });
  };

  const handleSubmit = (e, data, form) => {
    e.preventDefault();
    if (infoModalType === "bankAccountModal") {
      let parsedPayload = parseInput(data);
      let payload = {
        ...Object.except(parsedPayload, "newcompanyname"),
        accountHolderName: parsedPayload?.accountHolderName,
        accountNumber: parsedPayload?.accountNumber,
        accountHolderBankName: parsedPayload?.bankName,
        // accountHolderBankIFSC: parsedPayload?.accountHolderBankIFSC,
        creditSeen: parsedPayload?.creditSeen === "true" ? true : false,
        modeOfCredit: parsedPayload?.modeOfCredit,
      };
      if (data?.companyname === "OTHERS") {
        payload.companyname = data.newcompanyname;
      } else {
        payload.companyname = data.companyname;
      }
      console.log({ data, parsedPayload, payload });

      let applicationId = parseInt(props.urlparams.params.id);
      props.apis
        .apiUpdateUnderWriterAccountDetails(payload, {
          applicationId: applicationId,
        })
        .then(() => {
          swal2.fire({
            title: "Bank Account Details Updated Successfully",
            icon: "success",
            iconColor: "#FF4D4D",
            timer: 4000,
          });
          closeModal();
          getUnderwriterInfo();
        });
    } else {
      let payload = {
        ...Object.except(data, ["pfAmountDeducted", "newcompanyname"]),
        pfDeducted: data?.pfDeducted === "true" ? true : false,
        doj: new Date(data.doj).toISOString(),
        salaryCreditDate: new Date(data.salaryCreditDate).toISOString(),
      };
      if (data?.pfDeducted === "true") {
        payload.pfAmountDeducted = data?.pfAmountDeducted;
      } else {
        // delete payload.pfAmountDeducted;
        payload.pfAmountDeducted = "0";
      }

      if (data?.companyname === "OTHERS") {
        payload.companyname = data.newcompanyname;
      } else {
        payload.companyname = data.companyname;
      }
      console.log({ data, payload, editData });

      props.apis
        .apiUpdateUnderWriterApplicationIncome(payload, {
          applicationSalaryId: editData?.applicationSalaryId,
        })
        .then((res) => {
          console.log({ apiUpdateUnderWriterApplicationIncome: res });
          swal2.fire({
            title: "Income Details updated successfully.",
            icon: "success",
            iconColor: "#FF4D4D",
            timer: 4000,
          });
          closeModal();
          getUnderwriterInfo();
        })
        .catch((error) => console.log(error));
    }
  };
  // ----------------------------------------------------------------
  const [salaryInfoFields, setSalaryInfoFields] = useState([
    { date: "", amount: "" },
  ]);
  const [salaryInfoInputData, setSalaryInfoInputData] = useState([
    {
      label: "Date",
      name: "date",
      type: "date",
    },
    {
      label: "Amount",
      name: "amount",
      type: "number",
    },
  ]);
  const [bankAccountFields, setBankAccountFields] = useState([
    {
      label: "Bank Account Info.",
      name: "bankInfoTitle1",
      type: "textarea",
      customcolspan: 12,
      outerclass: "form-title",
    },
    {
      name: "bankName",
      label: "Bank Name",
      type: "text",
      readOnly: true,
    },
    {
      name: "accountNumber",
      label: "Account No.",
      type: "text",
      readOnly: true,
    },
    {
      name: "accountHolderName",
      label: "Account Holder Name",
      type: "text",
      readOnly: true,
    },
    {
      name: "accountType",
      label: "Account Type",
      type: "text",
      readOnly: true,
    },
    {
      name: "bankStatementPeriodFrom",
      label: "Bank Statement Period (From)",
      type: "date",
      readOnly: true,
    },
    {
      name: "bankStatementPeriodTo",
      label: "Bank Statement Period (To)",
      type: "date",
      readOnly: true,
    },
    {
      name: "creditSeen",
      label: "Credit Seen",
      type: "select",
      options: _enum.YES_OR_NO_BOOLEAN,
    },
    {
      name: "modeOfCredit",
      label: "Mode Of Credit",
      type: "select",
      options: _enum.MODE_OF_CREDIT,
      required: true,
    },
    {
      label: "Salary Credited Info.",
      name: "bankInfoTitle2",
      type: "textarea",
      customcolspan: 12,
      outerclass: "form-title",
    },
  ]);

  const editBankInfo = (e) => {
    setEditmode(true);
    setViewmode(false);

    let filteredData = Object.only(
      { ...summaryScoreData, ...creditsData },
      bankAccountFields.map((v) => v.name)
    );

    setEditData(summaryScoreData);
    setPopupdata(filteredData);

    let updatedFields = bankAccountFields?.map((field) => {
      return {
        ...field,
        defaultValue: filteredData[field?.name],
      };
    });
    setBankAccountFields([...updatedFields]);
    console.log({ summaryScoreData, filteredData, updatedFields });
    openModal("bankAccountModal");
  };
  const handleSalaryInfoSubmit = (e) => {
    let formData = e.target.parentNode.closest("form")?.getData();
    let parsedPayload = parseInput(formData);
    let payload = parsedPayload?.dynamicfield?.map((v) => {
      return {
        date: v?.date,
        amount: parseInt(v?.amount),
        applicationId: parseInt(props.urlparams.params.id),
      };
    });
    props.apis.apiUnderWriterAddSalaryCreditInfo(payload).then((res) => {
      swal2.fire({
        title: "Salary Credit Info Added successfully.",
        icon: "success",
        iconColor: "#FF4D4D",
        timer: 4000,
      });
      onModalClose();
      getUnderwriterInfo();
    });
  };

  const handleDynamicFieldUpdate = (e, id) => {
    let dateInputValue = document?.querySelector(
      `#dynamic-form-${id} [name='appinput-date'] input`
    )?.value;
    let amountInputValue = document?.querySelector(
      `#dynamic-form-${id} [name='appinput-amount'] input`
    )?.value;

    let payload = {
      date: dateInputValue,
      amount: parseInt(amountInputValue),
      month: dateInputValue?.moment().format("MMMM"),
    };

    // console.log({ id, payload });

    props.apis
      .apiUnderWriterUpdateSalaryCreditInfo(payload, { salaryCreditId: id })
      .then((res) => {
        // console.log({ res });
        swal2.fire({
          title: "Salary Credit Info Updated successfully.",
          icon: "success",
          iconColor: "#FF4D4D",
          timer: 4000,
        });
        onModalClose();
        getUnderwriterInfo();
      });
  };
  // ----------------------------------------------------------------
  const [showbankmodal, setShowbankmodal] = useState(false);
  const [showBankStatement, setShowBankStatement] = useState(false);
  const [activeBankStatement, setActiveBankStatement] = useState({});
  const [bankPassCheck, setBankPassCheck] = useState(false);
  const [bankstatementfiles, setBankstatementfiles] = useState({
    bankStatement1: {},
    bankStatement2: {},
    bankStatement3: {},
  });
  const [queryinfo, setQueryinfo] = useState([]);

  const addBankStatement = () => {
    setShowBankStatement(true);
  };

  const bankModalBtns = [
    {
      name: "bank_statement_1",
      label: "Bank Statement - 1",
      type: "modalFile",
      index: 1,
      modalTitle: "Month 1 - Bank Statement",
      placeholder: "Month 1 - Upload pdf",
      customcolspan: 4,
    },
    {
      name: "bank_statement_2",
      label: "Bank Statement - 2",
      type: "modalFile",
      index: 2,
      modalTitle: "Month 2 - Bank Statement",
      placeholder: "Month 2 - Upload pdf",
      customcolspan: 4,
    },
    {
      name: "bank_statement_3",
      label: "Bank Statement - 3",
      type: "modalFile",
      index: 3,
      modalTitle: "Month 3 - Bank Statement",
      placeholder: "Month 3 - Upload pdf",
      customcolspan: 4,
    },
  ];
  const bankFields = [
    {
      name: "bankname",
      label: "Bank Name",
      type: "select",
      options: _enum.STATIC_BANK_NAMES,
    },
    {
      name: "startDate",
      label: "Select Date",
      type: "date",
      placeholder: "From Date",
    },
    {
      name: "fileId",
      label: "Upload",
      type: "defaultfile",
      fileLabel: "Upload pdf",
      foldername: "bankStatementDocs",
      accept: "application/pdf",
    },
  ];

  const handleBSPasswordCheck = (e) => {
    let value = e.target.checked;
    setBankPassCheck(value);
  };

  const handleBankShow = (e, record) => {
    console.log({ record });
    setActiveBankStatement(record);
    setShowbankmodal(true);
  };

  const handleBSClose = (e) => {
    setActiveBankStatement({});
    setShowbankmodal(false);
    setBankPassCheck(false);
    // remove uploaded file from form
    // let fileInput = document.querySelector(
    //   `[name="appinput-fileId"] .filevalue_container`
    // );
    // console.log(editmode, fileInput);
    // if (editmode === false) {
    //   console.log("clear upload data");
    //   if (fileInput && fileInput.value.length > 0) {
    //     props.apis
    //       .apiFileRemover({ fileId: fileInput.value })
    //       .then((res) => {
    //         console.log({ apiFileRemover: res });
    //       })
    //       .catch((err) => {
    //         console.log({ err });
    //       });
    //   }
    // }
  };

  const handleBankStatementSubmit = (e, data) => {
    let payload = {
      ...Object.except(data, ["fileName", "startDate", "endDate"]),
      index: activeBankStatement?.index,
      filename: data?.fileId?.name?.filename() || "",
      startDate: new Date(data?.startDate).toISOString(),
    };
    console.log({ data, payload });
    setBankstatementfiles((prevState) => ({
      ...prevState,
      [`bankStatement${activeBankStatement?.index}`]: payload,
    }));
    setBankPassCheck(true);
    handleBSClose();
  };

  // ----------------------------------------------------------------
  // BANKING CONSENT
  // ----------------------------------------------------------------
  const [openBankingConsentModal, setOpenBankingConsentModal] = useState(false);
  const [popupBankingConsentData, setPopupBankingConsentData] = useState({});
  const [editBankingConsentData, setEditBankingConsentData] = useState({});
  const [popupBankingConsentFields, setPopupBankingConsentFields] = useState([]);
  const [editBankingConsentmode, setEditBankingConsentmode] = useState(false);
  const [viewBankingConsentmode, setViewBankingConsentmode] = useState(false);

  const [bankingConsentModalFields, setBankingConsentModalFields] = useState([
    {
      name: "mobileNumber",
      label: "Mobile Number",
      type: "text",
      required: true,
    },
  ]);

  const handleOpenBankingConsentModal = () => {
    let fields = (bankingConsentModalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    setPopupBankingConsentFields(fields);
    setPopupBankingConsentData(formdata);
    setOpenBankingConsentModal(true);
  };

  const handleCloseBankingConsentModal = () => {
    setOpenBankingConsentModal(false);
    setPopupBankingConsentData({});
    setEditBankingConsentData({});
    setPopupBankingConsentFields([]);
    setEditBankingConsentmode(false);
    setViewBankingConsentmode(false);
  };

  const startWindowMonitoring = () => {
    setIsPolling(true);
    // Clear existing interval if any
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
    }

    pollIntervalRef.current = setInterval(() => {
      if (popupRef.current && popupRef.current.closed) {
        // Window has been closed
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
        console.log("Consent window closed. Checking for completion...");
        checkConsentStatus();
      }
    }, 1000); // Check every second
  };

  const checkConsentStatus = () => {
    props.apis.apiGetUnderWriterApplicationDetails({
      applicationNumber: props.urlparams.params.id,
    }).then((res) => {
      console.log("check status res", res);
      let logs = res?.finduitLog?.webhookLogs || [];

      let c1 = null;
      let c2 = null;
      let c3 = null;

      logs.forEach(logStr => {
        try {
          let log = typeof logStr === 'string' ? JSON.parse(logStr) : logStr;

          if (log.frequency === "5 times a MONTH" && log.fetchType === "PERIODIC") {
            c1 = log.consentId;
          } else if (log.frequency === "1 times a DAY" && log.fetchType === "PERIODIC") {
            c2 = log.consentId;
          } else if (log.frequency === "1 times a DAY" && log.fetchType === "ONETIME") {
            c3 = log.consentId;
          }
        } catch (e) {
          console.error("Error parsing log string", e);
        }
      });

      if (c1 || c2 || c3) {
        setConsentData(prev => ({
          ...prev,
          consentId1: c1,
          consentId2: c2,
          consentId3: c3,
        }));

        // to get attachment pdf of last 1yr
        if (c3) fetchConsentData(c3, 'consentId3');

        setIsPolling(false);
        swal2.fire({
          title: "Consent Captured Successfully",
          icon: "success",
          timer: 3000
        });
      } else {
        console.warn("No matching consent logs found.");
        // Do not fail hard here as logs might be delayed, but the window closed.
        // Only show error if we are sure? 
        // BankConsent.jsx shows error or retry.
        // I'll show a warning toast/swal.
        swal2.fire({
          title: "Consent process incomplete or failed.",
          text: "Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
        setIsPolling(false);
      }
    }).catch(err => {
      console.error("Error checking consent status:", err);
      setIsPolling(false);
    });
  };

  const fetchConsentData = (consentId, fieldName) => {
    props.apis.apiFinduitConsentData({ consentId }).then((res) => {
      if (res && res.data && res.data.length > 0) {
        let pdfUrl = res.data[0]?.dataDetail?.pdfbase64;
        let name = res.data[0]?.dataDetail?.jsonData?.Account?.Profile?.Holders?.Holder?.name;

        if (pdfUrl && name) {
          let pdf = base64toPDF(pdfUrl, "bankstatement.pdf");
          console.log(`Fetched Consent Data for ${fieldName}:`, { pdf, name });

          // update consent pdf in fields
          setConsentData(prev => ({
            ...prev,
            pdf: pdf,
            pdfName: name,
          }));
        }
      }
    });
  }

  const base64toPDF = (base64String, fileName = 'bankstatement.pdf') => {
    if (typeof base64String === 'string' && (base64String.startsWith('http://') || base64String.startsWith('https://'))) {
      return base64String;
    }
    const base64Data = base64String.replace(/^data:application\/pdf;base64,/, "");
    const binaryString = window.atob(base64Data);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes.buffer], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  }

  const base64toExcel = (base64String, fileName = 'bankstatement.pdf') => {
    if (typeof base64String === 'string' && (base64String.startsWith('http://') || base64String.startsWith('https://'))) {
      return base64String;
    }
    const base64Data = base64String.replace(/^data:application\/vnd.ms-excel;base64,/, "");
    const binaryString = window.atob(base64Data);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }
    const blob = new Blob([bytes.buffer], { type: 'application/vnd.ms-excel' });
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  }

  const handleBankingConsentSubmit = (e, data) => {
    e.preventDefault();
    console.log("Banking Consent Data:", data);

    let mobileNumber = data?.mobileNumber;
    let applId = parseInt(props.urlparams.params.id);

    props.apis.apiFinduitConsentUrl({
      mobileNumber: mobileNumber,
    }, { applicationId: applId }).then((res) => {
      console.log("res", res);
      const redirectUrl = res?.redirectionUrl || res?.redirectionurl;
      if (redirectUrl) {
        // Open the URL in a new tab/window and store the reference
        popupRef.current = window.open(redirectUrl, "_blank", "width=800,height=600");
        startWindowMonitoring();
      } else {
        swal2.fire({
          title: "Failed to get redirection URL",
          icon: "error",
          timer: 2000,
        });
      }
    })
  };

  // ----------------------------------------------------------------

  const getQueries = () => {
    props.apis
      .apiUnderWriterGetApplicationQuery({
        applicationNumber: props.urlparams.params.id,
      })
      .then((res) => {
        let obj = Object.groupBy(res, (item) => {
          return item.category;
        });

        setQueryinfo(obj["INCOME_DTLS"] || []);
        // prepareSummaryInfo(res);
      });
  };

  // ----------------------------------------------------------------

  const handleApplicationSubmit = (e, data) => {
    console.log({ data });

    let monthlystatements = [
      bankstatementfiles.bankStatement1,
      bankstatementfiles.bankStatement2,
      bankstatementfiles.bankStatement3,
    ];

    let bankstatements = [...monthlystatements];

    let allKeysHaveValue = [...bankstatements].every((statements) => {
      return (
        Object.keys(statements).length > 0 &&
        Object.values(statements).every(
          (value) => value !== undefined && value !== ""
        )
      );
    });

    console.log({ allKeysHaveValue, bankstatements });

    if (!allKeysHaveValue) {
      console.log("Some keys do not have value in all objects");
      swal2.fire({
        title: "Please fill all required fields",
        icon: "error",
        iconColor: "#DE3232",
        timer: 3000,
        showCancelButton: false,
      });
    } else {
      console.log("All keys have value in all objects");

      // Call the function
      fetchValues(bankstatements, "bankstatement").then((bankstatementData) => {
        console.log({ bankstatementData });
        swal2
          .fire({
            title: "Loan Applied Successfully",
            icon: "success",
            iconColor: "#DE3232",
            confirmButtonColor: "#DE3232",
            confirmButtonText: "Close",
          })
          .then(() => {
            getUnderwriterInfo();
          });
      });
    }
  };

  // convert files to etag and
  async function fetchValues(objects, type) {
    const newObjects = [];

    for (const obj of objects) {
      let reqdata = {
        file: obj.fileId,
      };
      let filePayload = {};
      if (type === "bankstatement") {
        filePayload.foldername = "bankStatementDocs";
        props.apis
          .apiAddCustomerBSA(
            { file: obj.fileId },
            { applicationId: parseInt(props.urlparams.params.id) }
          )
          .then((res) => { })
          .catch((err) => {
            if (err) {
              console.log({ err });
              return;
            }
          });
      }

      const response = await props.apis
        .apiFileUploader(reqdata, filePayload)
        .catch((err) => {
          if (err) {
            console.log({ err });
          }
        });
      const data = await response;

      // Assuming the API response is an object with a single key
      const key = Object.keys(data)[0];
      const value = data[key];

      // Add a new property to the object with the fetched value
      const newObj = { ...obj, fileId: value };
      console.log({ newObj });

      var payload = {
        ...newObj,
      };
      if (type === "bankstatement") {
        const postresponse = await props.apis
          .apiAddCustomerBankStatament(payload)
          .catch((err) => {
            if (err) {
              console.log({ err });
            }
          });
        console.log(postresponse);
      }

      newObjects.push(newObj);
    }
    // console.log(`${type}:`, newObjects);
    return newObjects;
  }
  // ----------------------------------------------------------------

  const getUnderwriterInfo = () => {
    props.apis
      .apiGetUnderWriterApplicationDetails({
        applicationNumber: props.urlparams.params.id,
      })
      .then((res) => {
        setUwInfo(res);
        if (res.applicationPayslip.length > 0) {
          setPayslipfiles(res?.applicationPayslip);
        }
        setIncomedetails({
          ...res?.ApplicationSalaryInfo[0],
          officialEmailVerification: res?.customer?.officialEmailVerification,
        });
        if (res.applicationbankStatement.length > 0) {
          setBankStatementFiles(res?.applicationbankStatement);
        }
        if (res.applicationPayslip.length > 0) {
          setPayslipfiles(res.applicationPayslip);
        }
        if (res?.additionalDocsSubmitted) {
          setAdditionalDocs(
            res?.additionalDocsSubmitted?.filter((v) => v.category === "INCOME")
          );
        }
        setReferenceData({
          reference1name: res?.reference1name,
          reference1mobile: res?.reference1mobile,
          reference1relation: res?.reference1relation,
          reference1CallStatus: res?.reference1CallStatus,
          //
          reference2name: res?.reference2name,
          reference2mobile: res?.reference2mobile,
          reference2relation: res?.reference2relation,
          reference2CallStatus: res?.reference2CallStatus,
        });
        setSanctioneddocs({
          reference_details_1: {
            name: res?.reference1name,
            mobile_no: res?.reference1mobile,
            relation: _enum.RELATIONS_MAP[res?.reference1relation],
            call_status: res?.reference1CallStatus ? "Yes" : "No",
            colspan_key: "col-12 col-md-4",
            colspan_value: "col-12 col-md-4",
          },
          reference_details_2: {
            name: res?.reference2name,
            mobile_no: res?.reference2mobile,
            relation: _enum.RELATIONS_MAP[res?.reference2relation],
            call_status: res?.reference2CallStatus ? "Yes" : "No",
            colspan_key: "col-12 col-md-4",
            colspan_value: "col-12 col-md-4",
          },
        });
        if (res?.salaryCredits?.length > 0) {
          setSalaryCreditsData({
            salaryData: res.salaryCredits,
            cardData: res?.salaryCredits?.map((v) => {
              return {
                month: v.month,
                date: new Date(v?.date).dateToDDMMYYYY(new Date(v?.date)),
                amount: v.amount?.cur(),
              };
            }),
          });
        }
        setCreditsData({
          creditSeen: res?.creditSeen,
          modeOfCredit: res?.modeOfCredit,
        });

        if (typeof processBsaData === "function") {
          processBsaData(res?.bsaData || null);
        }

        // set banking consent fields

        let logs = res?.finduitLog?.webhookLogs || [];

        let c1 = null;
        let c2 = null;
        let c3 = null;

        logs.forEach(logStr => {
          try {
            let log = typeof logStr === 'string' ? JSON.parse(logStr) : logStr;

            if (log.frequency === "5 times a MONTH" && log.fetchType === "PERIODIC") {
              c1 = log.consentId;
            } else if (log.frequency === "1 times a DAY" && log.fetchType === "PERIODIC") {
              c2 = log.consentId;
            } else if (log.frequency === "1 times a DAY" && log.fetchType === "ONETIME") {
              c3 = log.consentId;
            }
          } catch (e) {
            console.error("Error parsing log string", e);
          }
        });

        if (c1 || c2 || c3) {
          setConsentData(prev => ({
            ...prev,
            consentId1: c1 || '',
            consentId2: c2 || '',
            consentId3: c3 || '',
          }));


          // to get attachment pdf of last 1yr
          if (c3) fetchConsentData(c3, 'consentId3');

        } 
        // else {
        //   swal2.fire({
        //     title: "Consent process incomplete or failed.",
        //     text: "Please try again.",
        //     icon: "error",
        //     confirmButtonText: "OK",
        //   });
        // }


        // --------------------------------------
      })
      .catch((error) => { });
  };

  // ----------------------------------------------------------------
  const [referrenceFields, setReferrenceFields] = useState([
    {
      label: "Reference 1",
      name: "refTitle1",
      type: "textarea",
      customcolspan: 12,
      outerclass: "form-title",
    },
    {
      name: "reference1name",
      label: "Name",
      type: "text",
    },
    {
      name: "reference1mobile",
      label: "Mobile No.",
      type: "number",
    },
    {
      name: "reference1relation",
      label: "Relationship",
      type: "select",
      options: _enum.RELATIONS_1,
    },
    {
      name: "reference1CallStatus",
      label: "Call Status",
      type: "select",
      options: _enum.YES_OR_NO_BOOLEAN,
    },
    {
      label: "Reference 2",
      name: "refTitle2",
      type: "textarea",
      customcolspan: 12,
      outerclass: "form-title",
    },
    {
      name: "reference2name",
      label: "Name",
      type: "text",
    },
    {
      name: "reference2mobile",
      label: "Mobile No.",
      type: "number",
    },
    {
      name: "reference2relation",
      label: "Relationship",
      type: "select",
      options: _enum.RELATIONS_2,
    },
    {
      name: "reference2CallStatus",
      label: "Call Status",
      type: "select",
      options: _enum.YES_OR_NO_BOOLEAN,
    },
  ]);
  const [editRefData, setEditRefData] = useState([]);
  const [editRefmode, setEditRefmode] = useState(false);
  const [viewRefmode, setviewRefmode] = useState(false);
  const [openRefCanvas, setOpenRefCanvas] = useState(false);
  const [popupReffields, setPopupReffields] = useState({});
  const [popupRefdata, setPopupRefdata] = useState({});
  // const [errorMessage, setErrorMessage] = useState({ name: "", message: "" });

  const openRefModal = () => {
    setOpenRefCanvas(true);
    addRefModalFields();
  };

  const closeRefModal = () => {
    setOpenRefCanvas(false);
  };

  const onRefModalClose = () => {
    console.log("onModalClose");
    closeRefModal();
    setPopupReffields({});
    setviewRefmode(false);
    setEditRefmode(false);
    setEditRefData({});
    // setErrorMessage({ name: "", message: "" });
  };

  const addRefModalFields = () => {
    let fields;
    fields = (referrenceFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );

    let formdata = Object.map(fields, (v, k) => "");
    setPopupReffields(fields);
    setPopupRefdata(formdata);
    setOpenRefCanvas(true);
  };

  const editRefInfo = (e) => {
    setEditRefmode(true);
    setviewRefmode(false);

    let refEditData = {
      ...referenceData,
    };
    console.log({ refEditData });

    let filteredData = Object.only(
      refEditData,
      referrenceFields.map((v) => v.name)
    );

    setPopupRefdata(filteredData);
    setEditRefData(refEditData);
    let updatedFields = referrenceFields?.map((field) => {
      return {
        ...field,
        defaultValue: filteredData[field?.name],
      };
    });
    setReferrenceFields([...updatedFields]);
    openRefModal();
  };

  useEffect(() => {
    let fields = (referrenceFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    setPopupReffields(fields);
  }, [editRefData]);

  const handleRefSubmit = (e, data, form) => {
    let payload = {
      ...Object.except(data, ["refTitle1", "refTitle2"]),
      reference1CallStatus:
        data?.reference1CallStatus === "true" ? true : false,
      reference2CallStatus:
        data?.reference2CallStatus === "true" ? true : false,
    };
    console.log({ payload });

    let applicationId = parseInt(props.urlparams.params.id);
    props.apis
      .apiUpdateUnderWriterReferenceDetails(payload, {
        applicationId: applicationId,
      })
      .then(() => {
        swal2.fire({
          title: "Reference Details Updated Successfully",
          icon: "success",
          iconColor: "#FF4D4D",
          timer: 4000,
        });
        closeRefModal();
        getUnderwriterInfo();
      });
  };
  // ----------------------------------------------------------------
  useEffect(() => {
    setBsaTableData(bankStatementFiles);
    setIsFetching(false);
    setBsaRowcount(0);
  }, [bankStatementFiles]);

  // ----------------------------------------------------------------
  const onPageChange = (pageData) => {
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 10,
    });
  };
  // show signzy generate button only on failure
  const [isDigitapFailed, setIsDigitapFailed] = useState(false);
  const [isSignzyFailed, setIsSignzyFailed] = useState(false);

  function startBsaCooldown(seconds = 30) {
    if (bsaCooldownTimerRef.current) {
      clearInterval(bsaCooldownTimerRef.current);
    }
    setBsaRetryCooldown(seconds);
    bsaCooldownTimerRef.current = setInterval(() => {
      setBsaRetryCooldown((prev) => {
        if (prev <= 1) {
          if (bsaCooldownTimerRef.current) {
            clearInterval(bsaCooldownTimerRef.current);
            bsaCooldownTimerRef.current = null;
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }

  function stopBsaCooldown() {
    if (bsaCooldownTimerRef.current) {
      clearInterval(bsaCooldownTimerRef.current);
      bsaCooldownTimerRef.current = null;
    }
    setBsaRetryCooldown(0);
  }

  useEffect(() => {
    if (!bsaPolling) {
      stopBsaCooldown();
    }

    return () => {
      stopBsaCooldown();
      if (bsaPollIntervalRef.current) {
        clearInterval(bsaPollIntervalRef.current);
        bsaPollIntervalRef.current = null;
      }
    };
  }, [bsaPolling]);

  function processBsaData(bsaObj) {
    setBsaData(bsaObj);
    if (!bsaObj) {
      setBsaPolling(false);
      return;
    }

    const status = bsaObj?.status ? String(bsaObj.status).toUpperCase() : "";
    const provider = bsaObj?.provider ? String(bsaObj.provider).toUpperCase() : "SIGNZY";
    const isDigitap = provider === "DIGITAP";
    const hasExcel = Boolean(bsaObj?.reportExcelUrl || bsaReportURL);

    const isSuccessStatus = ["COMPLETED", "SUCCESS", "ANALYSED"].includes(status);
    const isFailedStatus = ["FAILED", "ERROR", "FAILURE"].includes(status);
    const isSuccess = isSuccessStatus && (!isDigitap || hasExcel);
    const isPending = ["PENDING", "INPROGRESS", "IN PROGRESS", "UPLOADED", "INITIATED"].includes(status) || (isDigitap && isSuccessStatus && !hasExcel);

    if (isFailedStatus) {
      if (isDigitap) {
        setIsDigitapFailed(true);
      } else {
        setIsSignzyFailed(true);
      }
    }

    if (isSuccess && (bsaObj?.reportExcelUrl || bsaReportURL)) {
      if (bsaObj.reportExcelUrl) {
        setBsaReportURL(bsaObj.reportExcelUrl);
      }
      setBsaReportData(bsaObj);
      setBsaPolling(false);

      let accounts = bsaObj?.rawData?.accounts || bsaObj?.raw?.accounts || bsaObj?.accounts || [];
      let reportAccounts = bsaObj?.reportAccounts || bsaObj?.raw?.reportAccounts || bsaObj?.report?.reportAccounts || [];
      if (accounts.length > 0) {
        const account = accounts[0];
        let accountData = {
          bankName: account.bank || account.bankName || "",
          accountNumber: account.account_number || account.accountNumber || "",
          accountHolderName: bsaObj?.raw?.customer_info?.name || "",
          accountType: account.account_type_name || account.accountTypeName || account.account_type || account.accountType || "",
          bankStatementPeriodFrom: account.transaction_start_date || account.startDate || account.fromDate || "",
          bankStatementPeriodTo: account.transaction_end_date || account.endDate || account.tillDate || "",
        };
        setSummaryScoreData({
          ...accountData,
          bankScore: bsaObj?.bankScore || bsaObj?.raw?.report?.bankScore || bsaObj?.report?.bankScore || "",
          colspan_key: "col-12 col-md-4",
          colspan_value: "col-12 col-md-4",
        });
      } else if (reportAccounts.length > 0) {
        let {
          bankName,
          accountNumber,
          accountHolderName,
          accountName,
          accountTypeName,
          accountType,
          startDate,
          endDate,
        } = reportAccounts[0]?.account || reportAccounts[0] || {};
        let accountData = {
          bankName: bankName || "",
          accountNumber: accountNumber || "",
          accountHolderName: accountHolderName || accountName || "",
          accountType: accountTypeName || accountType || "",
          bankStatementPeriodFrom: startDate || reportAccounts[0]?.files?.[0]?.fromDate || "",
          bankStatementPeriodTo: endDate || reportAccounts[0]?.files?.[0]?.tillDate || "",
        };
        setSummaryScoreData({
          ...accountData,
          bankScore: bsaObj?.bankScore || bsaObj?.raw?.report?.bankScore || bsaObj?.report?.bankScore || "",
          colspan_key: "col-12 col-md-4",
          colspan_value: "col-12 col-md-4",
        });
      }
    } else if (isSuccess && !bsaObj?.reportExcelUrl && !bsaReportURL) {
      if (!hasFetchedReportRef.current && !bsaPolling) {
        hasFetchedReportRef.current = true;
        fetchBsaReportFiles(bsaObj);
      }
    } else if (isPending) {
      setBsaStatusMessage("Analysis has started, retry after 30s");
      setBsaPolling(true);
      if (!bsaCooldownTimerRef.current && bsaRetryCooldown === 0) {
        startBsaCooldown(30);
      }
    } else {
      setBsaPolling(false);
      stopBsaCooldown();
    }
  }

  function fetchBsaReportFiles(bsaObj) {
    const provider = bsaObj?.provider || "SIGNZY";
    const workOrderId = bsaObj?.workOrderId || bsaObj?.txnId || props.urlparams.params.id;
    const appId = props.urlparams.params.id;

    setBsaStatusMessage("Fetching report files...");
    setBsaPolling(true);

    const apiCall = (provider === "DIGITAP")
      ? props.apis.apiRetrieveDigitapReport({ txn_id: workOrderId || appId })
      : props.apis.apiUnderWriterGetBsaReport({ applicationNumber: appId });

    apiCall
      .then((reportRes) => {
        console.log("Report fetched and cached successfully:", reportRes);
        getUnderwriterInfo();
      })
      .catch((err) => {
        console.error("Error fetching report:", err);
        if (provider !== "DIGITAP" && workOrderId) {
          props.apis.apiRetrieveDigitapReport({ txn_id: workOrderId })
            .then(() => getUnderwriterInfo())
            .catch(() => {
              setBsaPolling(false);
              setBsaStatusMessage("Failed to download report files.");
            });
        } else if (provider === "DIGITAP") {
          props.apis.apiUnderWriterGetBsaReport({ applicationNumber: appId })
            .then(() => getUnderwriterInfo())
            .catch(() => {
              setBsaPolling(false);
              setBsaStatusMessage("Failed to download report files.");
            });
        } else {
          setBsaPolling(false);
          setBsaStatusMessage("Failed to download report files.");
        }
      });
  }

  function checkBsaStatus() {
    setBsaStatusMessage("Checking status...");
    props.apis
      .apiUnderWriterVerifyBsaStatus({
        applicationNumber: props.urlparams.params.id,
      })
      .then((res) => {
        const status = res?.status || res?.bsaData?.status || "";
        const statusUpper = String(status).toUpperCase();
        const isSuccess = ["COMPLETED", "SUCCESS", "ANALYSED"].includes(statusUpper);
        const isFailed = ["FAILED", "ERROR", "FAILURE"].includes(statusUpper);

        if (isSuccess) {
          stopBsaCooldown();
          if (bsaPollIntervalRef.current) {
            clearInterval(bsaPollIntervalRef.current);
            bsaPollIntervalRef.current = null;
          }
          setBsaPolling(false);
          const provider = res?.provider || res?.bsaData?.provider || bsaData?.provider || "";
          const isDigitap = String(provider).toUpperCase() === "DIGITAP";
          if (isDigitap && !res?.reportExcelUrl && !res?.bsaData?.reportExcelUrl && !bsaReportURL) {
            fetchBsaReportFiles(res?.bsaData || res || bsaData || {});
          } else {
            getUnderwriterInfo();
          }
        } else if (isFailed) {
          stopBsaCooldown();
          if (bsaPollIntervalRef.current) {
            clearInterval(bsaPollIntervalRef.current);
            bsaPollIntervalRef.current = null;
          }
          setBsaPolling(false);
          const provider = res?.provider || res?.bsaData?.provider || bsaData?.provider || "";
          const isDigitap = String(provider).toUpperCase() === "DIGITAP";
          if (isDigitap) {
            setIsDigitapFailed(true);
          } else {
            setIsSignzyFailed(true);
          }
          const failedStatus = status || "FAILED";
          if (res?.bsaData || res) {
            setBsaData((prev) => ({
              ...(prev || {}),
              ...(res?.bsaData || res),
              status: failedStatus,
            }));
          } else {
            setBsaData((prev) => (prev ? { ...prev, status: failedStatus } : { status: failedStatus }));
          }
          swal2.fire({
            title: "BSA analysis failed! \n Please re-try",
            icon: "error",
            iconColor: "#FF4D4D",
            timer: 2000,
          });
        } else {
          setBsaStatusMessage("Analysis has started, retry after 30s");
          startBsaCooldown(30);
          swal2.fire({
            title: "Analysis in progress",
            text: "Still analyzing the documents. Please retry after 30 seconds.",
            icon: "info",
            iconColor: "#3085d6",
            timer: 2500,
          });
        }
      })
      .catch((err) => {
        console.error("Error checking BSA status:", err);
        setBsaStatusMessage("Analysis has started, retry after 30s");
        startBsaCooldown(30);
        swal2.fire({
          title: "Failed to verify status",
          text: "Could not check analysis status right now. Please retry shortly.",
          icon: "error",
          iconColor: "#FF4D4D",
          timer: 2000,
        });
      });
  }

  function generateReport(params = {}) {
    setIsDigitapFailed(false);
    setIsSignzyFailed(false);
    setBsaStatusMessage("Initiating analysis...");
    setBsaPolling(true);
    hasFetchedReportRef.current = false;

    props.apis
      .apiUnderWriterGenerateBsaReport({
        applicationNumber: props.urlparams.params.id,
      }, { ...params })
      .then((res) => {
        swal2.fire({
          title: "BSA Report generation started! \n Please check in sometime",
          icon: "success",
          iconColor: "#FF4D4D",
          timer: 2000,
        });
        setBsaStatusMessage("Analysis has started, retry after 30s");
        startBsaCooldown(30);
        getUnderwriterInfo();
      })
      .catch((err) => {
        setBsaPolling(false);
        stopBsaCooldown();
        setIsSignzyFailed(true);
        swal2.fire({
          title: "Failed to start BSA analysis!",
          text: err?.response?.data?.message || "Please try again",
          icon: "error",
          iconColor: "#FF4D4D",
          timer: 2000,
        });
      });
  }

  function fetchBSAStatus() {
    if (bsaData?.status && ["COMPLETED", "SUCCESS", "ANALYSED"].includes(String(bsaData.status).toUpperCase()) && !bsaData?.reportExcelUrl) {
      hasFetchedReportRef.current = true;
      fetchBsaReportFiles(bsaData);
    } else {
      checkBsaStatus();
    }
  }

  const bsaStatus = bsaData?.status ? String(bsaData.status).toUpperCase() : "";
  const isBsaFailed = isDigitapFailed || isSignzyFailed || ["FAILED", "ERROR", "FAILURE"].includes(bsaStatus);
  const isBsaSuccess = ["COMPLETED", "SUCCESS", "ANALYSED"].includes(bsaStatus) && !isBsaFailed;
  const isBsaPending = (["PENDING", "INPROGRESS", "IN PROGRESS", "UPLOADED", "INITIATED"].includes(bsaStatus) || bsaPolling) && !isBsaFailed;
  const hasBsaReport = isBsaSuccess && Boolean(bsaData?.reportExcelUrl || bsaReportURL);
  const isBsaMissingReport = isBsaSuccess && !bsaData?.reportExcelUrl && !bsaReportURL;

  // ----------------------------------------------------------------

  const [additionalDocFields, setAdditionalDocFields] = useState([
    {
      docType: "",
      fileName: "",
      fileId: "",
    },
  ]);
  const addMoreDocs = () => {
    setAdditionalDocFields([
      ...additionalDocFields,
      {
        docType: "",
        fileName: "",
        fileId: "",
      },
    ]);
  };
  const deleteDocField = (params, index, id) => {
    // console.log({ id });
    if (id !== "") {
      let payload = {
        fileId: id,
        applicationId: parseInt(props.urlparams.params.id),
      };
      // console.log({ payload });

      props.apis.apiUnderWriterDeleteAdditionalDocs(payload).then((res) => {
        getUnderwriterInfo();
      });
    } else {
      let data = [...additionalDocFields];
      data.splice(index, 1);
      setAdditionalDocFields(data);
    }
  };

  const handleAdditionalDocsChange = (args, index) => {
    var documentNameInputCol = document.querySelector(
      `#column${index}-fileName`
    );
    var documentNameInput = document.querySelector(
      `#column${index}-fileName [name="additionalDoc.${index}.fileName"]`
    );

    // console.log(documentNameInputCol, documentNameInput);
    const hasOthers = args?.some((obj) => obj.key === "OTHERS");
    if (hasOthers) {
      documentNameInputCol.classList.remove("d-none");
      documentNameInput.setAttribute("required", true);
    } else {
      documentNameInputCol.classList.add("d-none");
      documentNameInput.removeAttribute("required");
    }
  };

  const resolveResponse = (msg) => {
    swal2.fire({
      title: msg,
      icon: "success",
      iconColor: "#DE3232",
      confirmButtonColor: "#DE3232",
      confirmButtonText: "Close",
      timer: 3000,
    });
  };
  const handleAdditionalDocsSubmit = async (e, data) => {
    e.preventDefault();
    if (data) {
      let parsedPayload = parseInput(data);
      let payload = parsedPayload?.additionalDoc?.map((item) => {
        return {
          ...item,
          fileName: item?.fileName || item?.docType?.toTitleCase(),
          docType: item?.docType,
          category: "INCOME",
        };
      });

      const finalPayload = [];

      for (const obj of payload) {
        let reqdata = {
          file: obj.fileId,
        };
        let filePayload = {
          foldername: "underwriterDocs",
          applicationId: parseInt(props.urlparams.params.id),
          category: "INCOME",
        };

        const response = await props.apis
          .apiFileUploader(reqdata, filePayload)
          .catch((err) => {
            if (err) {
              console.log({ err });
            }
          });
        const uploadFileResData = await response;

        const key = Object.keys(uploadFileResData)[0];
        const value = uploadFileResData[key];
        const newObj = { ...obj, fileId: value };

        finalPayload.push(newObj);
      }
      if (finalPayload) {
        let applicationId = parseInt(props.urlparams.params.id);
        props.apis
          .apiUpdateUnderWriterAdditionalDocs(finalPayload, {
            applicationId: applicationId,
          })
          .then((res) => {
            resolveResponse("Additional Documents Added Successfully");
            additionalDocForm?.current?.form?.current?.reset();
            getUnderwriterInfo();
            setAdditionalDocFields([
              {
                docType: "",
                fileName: "",
                fileId: "",
              },
            ]);
          });
      }
    }
  };

  const updateFields = (fields, data) => {
    let result = fields?.map((field) => {
      let filteredData = Object.only(
        data,
        fields.map((v) => v.name)
      );

      if (field.name === "companyname") {
        // console.log(field, data[field?.name]);
        var companyNameInput = document.querySelector(
          "[name='appinput-companyname'].form-group"
        );
        var newCompanyNameInput = document.querySelector(
          "[name='newcompanyname']"
        );
        // console.log(companyNameInput, newCompanyNameInput);

        if (companyNameInput) {
          var companySelect = companyNameInput?.vnode.refs.select;
          // console.log({ companySelect });

          if (companySelect && companySelect?.state?.values?.length === 0) {
            let value = filteredData[field.name];
            let payload = {
              companyName: value,
            };
            if (value?.length >= 3) {
              props.apis.apiGetMasterCompanies(payload).then(({ data }) => {
                if (data) {
                  // console.log({ "search data": data });
                  if (companySelect) {
                    companySelect = companyNameInput.vnode.refs.select;
                    let { searchResults } = companySelect?.state || {};
                    let datawithkey = data?.options("companyName");
                    // console.log({ searchResults, datawithkey });

                    if (data.length === 0) {
                      companySelect?.setState(
                        {
                          searchResults: [{ key: "OTHERS", label: "Others" }],
                          values: [{ key: "OTHERS", label: "Others" }],
                        },
                        () => {
                          companySelect?.setState({
                            searchResults,
                            values: [{ key: "OTHERS", label: "Others" }],
                          });
                        }
                      );
                      newCompanyNameInput.value = value;
                    } else {
                      companySelect?.setState({
                        searchResults,
                        values: [
                          {
                            key: datawithkey[0].key,
                            label: datawithkey[0].label,
                          },
                        ],
                      });
                    }
                  }
                }
              });
            }
          }
        }
      }
      return {
        ...field,
        defaultValue: data[field?.name],
        // disabled: true,
      };
    });
    // console.log(result);
    return result;
  };
  // ----------------------------------------------------------------

  useEffect(() => {
    setTimeout(() => {
      let updatedFields = updateFields(modalFields, editData);
      console.log({ updatedFields });
    }, 500);
  }, [editData]);

  useEffect(() => {
    getUnderwriterInfo();
    getCompanies();
    getQueries();
    // fetchBSAStatus();
  }, []);

  const handleDecision = (e, data) => {
    let parsedPayload = parseInput(data);
    // console.log("formData", data, parsedPayload);
    let payload = {
      ...parsedPayload,
      applicationId: parseInt(props.urlparams.params.id),
      category: "INCOME_DTLS",
    };
    console.log({ payload });
    props.apis
      .apiUnderWriterCreateApplicationQuery(payload)
      .then((res) => {
        swal2.fire({
          title: "Underwriter Decision Updated successfully.",
          icon: "success",
          iconColor: "#FF4D4D",
          timer: 4000,
        });
        props.changeTab(e, "cibil");
      })
      .catch((error) => { });
  };

  const getBankLink = () => {
    let link;
    if (frompath === "loanapplications") {
      link = `/app/loanapplications?activetab=${tabStatus}`;
    }
    if (frompath === "dupecheck") {
      link = `/app/dupecheck`;
    }
    return link;
  };

  props.$setNode({
    props,
    payslipfiles,
    modalFields,
    editData,
  });

  return (
    <>
      <div className="card p-4">
        <FlexCard
          title="Salary Info."
          data={{
            applicationId: incomedetails?.applicationSalaryId,
            ...Object.except(incomedetails, [
              "netMonthlyIncome",
              "remarks",
              "finalNetSalary",
              "salaryCreditDate",
              "applicationSalaryId",
              "fileName",
              "isSalaried",
              "officialEmailVerification",
            ]),
            pfDeducted: incomedetails?.pfDeducted ? "Yes" : "No",
            pfAmountDeducted:
              incomedetails?.pfDeducted === true
                ? incomedetails?.pfAmountDeducted?.cur()
                : "-",
            monthlySalary: incomedetails?.monthlySalary?.cur(),
            monthlyNetTakeSalary: incomedetails?.monthlyNetTakeSalary?.cur(),
            doj:
              incomedetails?.doj !== null
                ? new Date(incomedetails?.doj).dateToDDMMYYYY(
                  new Date(incomedetails?.doj)
                )
                : "-",
            finalNetSalary: incomedetails?.finalNetSalary?.cur(),
            salaryCreditDate: incomedetails?.salaryCreditDate
              ? new Date(incomedetails?.salaryCreditDate).dateToDDMMYYYY(
                new Date(incomedetails?.salaryCreditDate)
              )
              : "-",
            avgMonthlyBalance: incomedetails?.avgMonthlyBalance?.cur(),
            remarks: incomedetails?.remarks,
          }}
          verifiedIconsFor={
            uwInfo?.customer?.officialEmailVerification === true
              ? ["officialEmail"]
              : []
          }
          editable={
            isReadonly ? false : tabStatus !== "inprogress" ? false : true
          }
          onEdit={(...args) => editSalaryInfo(...args, incomedetails)}
          hasOfficeId={incomedetails?.officeCardId !== undefined ? true : false}
          officeIdKey="officeCardId"
        />
      </div>

      {/* Referrence details */}

      <div className="card p-4">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-5">
            <FlexCard
              title="Reference Details - 1"
              data={
                sanctioneddocs
                  ? {
                    ...Object.except(sanctioneddocs?.reference_details_1, [
                      "colspan_key",
                      "colspan_value",
                    ]),
                  }
                  : null
              }
              colspan_key={
                sanctioneddocs &&
                sanctioneddocs?.reference_details_1?.colspan_key
              }
              colspan_value={
                sanctioneddocs &&
                sanctioneddocs?.reference_details_1?.colspan_value
              }
            />
          </div>
          <div className="col-12 col-md-2 col-lg-2 d-flex align-item-center justify-content-center">
            <div className="v_line"></div>
          </div>
          <div className="col-12 col-md-12 col-lg-5">
            <FlexCard
              title="Reference Details - 2"
              data={
                sanctioneddocs
                  ? {
                    ...Object.except(sanctioneddocs?.reference_details_2, [
                      "colspan_key",
                      "colspan_value",
                    ]),
                  }
                  : null
              }
              colspan_key={
                sanctioneddocs &&
                sanctioneddocs?.reference_details_2?.colspan_key
              }
              colspan_value={
                sanctioneddocs &&
                sanctioneddocs?.reference_details_2?.colspan_value
              }
              editable={isReadonly ? false : true}
              onEdit={(...args) => editRefInfo(...args)}
            />
          </div>
        </div>
      </div>

      {/* Banking Consent */}
      <div className="card p-4">
        <div className="form_group_card px-0">
          <div className="d-flex align-items-start justify-content-between">
            <h2 className="mb-3 theme_text_sm">Banking Consent</h2>

            {(uwInfo?.finduitLog === null || uwInfo?.finduitLog?.consentId === null) && (
              <button
                type="button"
                className={Object.className({
                  "btn btn-primary": true,
                  "d-none": isReadonly,
                })}
                onClick={(...args) => handleOpenBankingConsentModal(...args)}
              >
                Initiate Consent
              </button>
            )}
          </div>
          <div className="row">
            <div className="col-6 col-md-4">
              <AppInput
                name="consentId1"
                label="Consent ID 1 (Last 1 Yr)"
                type="text"
                value={consentData?.consentId1}
              />
            </div>
            <div className="col-6 col-md-4">
              <AppInput
                name="consentId2"
                label="Consent ID 2 (Last 6 Months)"
                type="text"
                value={consentData?.consentId2}
              />
            </div>
            <div className="col-6 col-md-4">
              <AppInput
                name="consentId3"
                label="Consent ID 3 (Last 3 Months)"
                type="text"
                value={consentData?.consentId3}
              />
            </div>

            <div className="col-6 col-md-4">
              <label className="col-form-label" htmlFor="bankStatement">Bank Statement</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  id="bankStatement"
                  name="bankStatement"
                  value={consentData.pdfName || ""}
                  readOnly />
                <a href={consentData.pdf || "#"}
                  {...(consentData.pdf && consentData.pdfName && consentData.pdfName.endsWith('.pdf') ? {
                    download: consentData.pdfName
                  } : {})}
                  className="btn btn-outline-secondary">
                  <i className="fa fa-download"></i>
                </a>
              </div>
            </div>

          </div>

        </div>
      </div>

      {/* Payslips */}
      <div className="card p-4">
        <div className="form_group_card px-0">
          <div className="d-flex align-items-start justify-content-between">
            <h2 className="mb-3 theme_text_sm">Last 3 months pay slip</h2>
            {/* <button
              type="button"
              className={Object.className({
                "btn btn-primary-transparent": true,
                "d-none": isReadonly,
              })}
              onClick={(...args) => handleShow(...args)}
            >
              + Add Payslip
            </button> */}
          </div>
          <div className="row g-4">
            {payslipfiles &&
              payslipfiles.map((file, i) => {
                return (
                  <>
                    <div className="col-12 col-md-4 file_download_box">
                      <p className="label_text">Pay slip - {i + 1}</p>
                      <a
                        href={`${BASE_URL}${file?.fileId}`}
                        className="file_download_btn position-relative"
                      >
                        <span>Month {i + 1} - Download pdf</span>
                        <i className="fa fa-download"></i>
                        {i >= 3 && (
                          <button
                            onClick={(...args) => deleteField(...args, i)}
                            className="btn transparent_trash_btn"
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        )}
                      </a>
                      {file?.filePassword && (
                        <p className="mt-1">
                          File Password: {file?.filePassword}
                        </p>
                      )}
                    </div>
                  </>
                );
              })}
          </div>
        </div>
      </div>

      {/* Bank Statement Analyzer */}
      <div className="card p-4">
        <div className="form_group_card px-0">
          <div className="d-flex align-items-start justify-content-between">
            <h2 className="mb-3 theme_text_sm">Bank Statement Analyzer</h2>
            <div className="action_btn_group d-flex align-items-start">
              <button
                type="button"
                className={Object.className({
                  "btn btn-primary-transparent py-0": true,
                  "border-right-0": isReadonly,
                })}
              >
                <i className="fa fa-download me-2"></i>
                Download All
              </button>
              {/* <button
                type="button"
                className={Object.className({
                  "btn btn-primary-transparent py-0": true,
                  "d-none": isReadonly,
                })}
                onClick={(...args) => addBankStatement(...args)}
              >
                + Add Bank Statement
              </button> */}
            </div>
          </div>
          {/* <div className="row g-4 px-0 mt-3">
            {bankStatementFiles.length > 0 &&
              bankStatementFiles?.map((file, i) => {
                return (
                  <>
                    <div className="col-12 col-md-4 file_download_box">
                      <p className="label_text">Bank Statement - {i + 1}</p>
                      <a
                        href={`${BASE_URL}${file?.fileId}`}
                        className="file_download_btn"
                      >
                        <span>{file.filename}</span>
                        <i className="fa fa-download"></i>
                      </a>
                    </div>
                  </>
                );
              })}
          </div> */}

          <div>
            <AppTable
              data={bsaTableData}
              columns={bsaColumns}
              onChange={(...arg) => onPageChange(...arg)}
              total={bsaRowcount}
              reorder={true}
              editable={false}
              viewable={false}
              deletable={false}
              // actionBtn={true}
              // actionBtnAction={(...args) => fetchBSAStatus(...args)}
              // actionBtnText="Get Report"
              loading={isFetching}
            ></AppTable>
          </div>
        </div>
        {!hasBsaReport && (
          <div className="card-footer border-0 text-end">
            {isBsaPending ? (
              <div className="d-inline-flex align-items-center">
                <div className="spinner-border text-primary spinner-border-sm me-2" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <span className="text-primary font-weight-bold me-3">
                  {bsaStatusMessage || "Analysis in progress..."}
                </span>
                {bsaStatusMessage !== "Initiating analysis..." && bsaStatusMessage !== "Fetching report files..." && (
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    disabled={bsaRetryCooldown > 0 || bsaStatusMessage === "Checking status..."}
                    onClick={() => checkBsaStatus()}
                  >
                    {bsaRetryCooldown > 0 ? `Retry (${bsaRetryCooldown}s)` : "Check Status Now"}
                  </button>
                )}
              </div>
            ) : isBsaMissingReport ? (
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => fetchBsaReportFiles(bsaData || {})}
              >
                Fetch Report
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => generateReport()}
                >
                  Analyze
                </button>
                {isDigitapFailed && (
                  <button
                    type="button"
                    className="btn btn-primary ms-3"
                    onClick={() => generateReport({ forceProvider: "SIGNZY" })}
                  >
                    Retry
                  </button>
                )}
                {isSignzyFailed && (
                  <button
                    type="button"
                    className="btn btn-primary ms-3"
                    onClick={() => generateReport({ forceProvider: "DIGITAP" })}
                  >
                    Retry
                  </button>
                )}
              </>
            )}
          </div>
        )}

        <div
          className={Object.className({
            "card-body p-0": true,
            "d-none": !hasBsaReport,
          })}
        >
          <div className="action_btn_group text-end">
            {(bsaData?.reportExcelUrl || bsaReportURL) && (
              <button type="button" className="btn btn-primary-transparent me-2">
                <a
                  href={bsaData?.reportExcelUrl || bsaReportURL}
                  className="file_download_btn text-primary"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-download me-2"></i>
                  Download Excel
                </a>
              </button>
            )}
          </div>

          {summaryScoreData && (
            <div className="card grey_bordered py-4">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-6">
                  <FlexCard
                    className=""
                    title="Bank Account Info."
                    data={
                      summaryScoreData
                        ? {
                          ...Object.except(summaryScoreData, [
                            "colspan_key",
                            "colspan_value",
                          ]),
                          ...creditsData,
                          creditSeen:
                            creditsData?.creditSeen === true ? "Yes" : "No",
                        }
                        : null
                    }
                    colspan_key={
                      summaryScoreData && summaryScoreData?.colspan_key
                    }
                    colspan_value={
                      summaryScoreData && summaryScoreData?.colspan_value
                    }
                  />
                </div>
                <div className="col-12 col-md-12 col-lg-6">
                  <div className="flex_card_outer">
                    <button
                      type="button"
                      className="btn edit_btn"
                      onClick={(e) => editBankInfo(e)}
                    >
                      <i className="fa fa-pencil"></i>
                    </button>
                    <div className="flex_card row">
                      <h4 className="title">Salary Credited Info.</h4>
                      {salaryCreditsData &&
                        salaryCreditsData?.cardData?.map((item, i) => {
                          return Object.entries(item).map(([key, value], i) => (
                            <div className="card-item col-12 col-md-4">
                              <div className="card-key">
                                {key?.toTitleCase()}
                              </div>
                              <div className="card-value">{value}</div>
                            </div>
                          ));
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        className={Object.className({
          "card p-4": true,
          "d-none": !showBankStatement,
        })}
      >
        <AppForm
          onSubmit={handleApplicationSubmit}
          className="bank_modal_btns_container"
        >
          {bankModalBtns?.map((field, i) => {
            return (
              <div
                className={`col-12 col-md-${field?.customcolspan || 6}`}
                key={i}
              >
                <div className="modal_file_container">
                  <label>
                    {field?.label}
                    {/* <span className="text-danger">*</span> */}
                  </label>
                  {Object.keys(bankstatementfiles[`bankStatement${i + 1}`])
                    .length > 0 ? (
                    <>
                      <Button
                        variant="dark"
                        onClick={(...args) => handleBankShow(...args, field)}
                        className="w-100 text-left"
                      >
                        {
                          bankstatementfiles[`bankStatement${i + 1}`][
                          "filename"
                          ]
                        }
                      </Button>
                      {/* <button
                            type="button"
                            onClick={(...args) =>
                              handleFileDownload(
                                ...args,
                                editdata?.applicationPayslip[i]
                              )
                            }
                            className="file_name_btn"
                          >
                            {bankstatementfiles[`bankStatement${i + 1}`]["filename"]}
                            <i class="fa-solid fa-download"></i>
                          </button> */}
                    </>
                  ) : (
                    <Button
                      variant="dark"
                      onClick={(...args) => handleBankShow(...args, field)}
                      className="w-100 text-left"
                    >
                      {field.placeholder}
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
          <div className="card-footer border-0 text-end">
            <button type="submit" className="btn btn-primary">
              Generate Report
            </button>
          </div>
        </AppForm>
      </div>

      {/* ADDITIONAL DOCS CARD */}
      <div
        className={Object.className({
          "card profile_card p-4": true,
          "d-none": isReadonly ? true : false,
        })}
      >
        <div className="card-header p-0 border-0">
          <div className="d-flex align-items-center mb-3">
            <img
              src={imagepaths.cardGaurdIcon}
              alt="cardGaurdIcon"
              className="card_icon"
            />
            <h5 className="title ms-2 mb-0">Additional Documents</h5>
          </div>
        </div>
        <div className="py-4">
          <AppForm
            ref={additionalDocForm}
            onSubmit={(...args) => handleAdditionalDocsSubmit(...args)}
          >
            {additionalDocFields?.map((item, i) => (
              <div className="row" key={i}>
                <div className="col-12 col-md-3" id={`column${i}-docType`}>
                  <AppInput
                    name={`additionalDoc.${i}.docType`}
                    label="Document Type"
                    type="select"
                    options={_enum.DOC_TYPES_NEW_WITH_OTHERS}
                    onChange={(e) => handleAdditionalDocsChange(e, i)}
                    required
                  ></AppInput>
                </div>
                <div
                  className="col-12 col-md-3 d-none"
                  id={`column${i}-fileName`}
                >
                  <AppInput
                    name={`additionalDoc.${i}.fileName`}
                    label="Document Name"
                    type="text"
                    required
                  ></AppInput>
                </div>
                <div className="col-12 col-md-3" id={`column${i}-fileId`}>
                  <AppInput
                    name={`additionalDoc.${i}.fileId`}
                    label="Upload Document"
                    type="defaultfile"
                    fileLabel="Upload document"
                    foldername="underwriterDocs"
                    required
                  ></AppInput>
                </div>
                {i != 0 && (
                  <div
                    className={Object.className({
                      "col-12 col-md-3 d-flex align-items-center": true,
                    })}
                  >
                    <button
                      type="button"
                      onClick={(...args) =>
                        deleteDocField(...args, i, item?.fileId)
                      }
                      className={Object.className({
                        "btn btn-primary mt-4": true,
                        "d-none": isReadonly,
                      })}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                )}
              </div>
            ))}
            <div className="action_btn_group mb-4 d-flex align-items-center justify-content-between">
              <button
                type="button"
                className={Object.className({
                  "btn btn-primary-transparent p-0 fs-5 border-right-0": true,
                  "d-none": isReadonly,
                })}
                onClick={(...args) => addMoreDocs(...args)}
              >
                + Add more document
              </button>
              <button
                type="submit"
                className={Object.className({
                  "btn btn-primary": true,
                  "d-none": isCpa,
                })}
              >
                Submit
              </button>
            </div>
          </AppForm>

          {additionalDocs &&
            additionalDocs?.map((item, i) => {
              return (
                <div className="row" key={i}>
                  <div className="col-12 col-md-3">
                    <AppInput
                      name="docType"
                      label="Document Type"
                      defaultValue={item?.docType}
                      type="select"
                      options={_enum.DOC_TYPES_NEW_WITH_OTHERS}
                      required
                      disabled={true}
                    ></AppInput>
                  </div>
                  <div className="col-12 col-md-3">
                    <AppInput
                      name="fileName"
                      label="Document Name"
                      defaultValue={item?.fileName}
                      type="text"
                      required
                      disabled={true}
                    ></AppInput>
                  </div>
                  <div className="col-12 col-md-3">
                    <AppInput
                      name="fileId"
                      label="Upload Document"
                      type="file"
                      defaultValue={item?.fileId || ""}
                      fileLabel="Upload document"
                      foldername="underwriterDocs"
                      required
                      disabled={true}
                    ></AppInput>
                  </div>
                  <div
                    className={Object.className({
                      "col-12 col-md-3 d-flex align-items-center": true,
                    })}
                  >
                    <button
                      type="button"
                      onClick={(...args) =>
                        deleteDocField(...args, i, item?.fileId)
                      }
                      className={Object.className({
                        "btn btn-primary": true,
                        "d-none": isReadonly,
                      })}
                    >
                      <i className="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>

      {isReadonly ? (
        <div className="nav_container mt-5">
          <Link to={getBankLink()} className="btn btn-primary-lite me-3">
            Cancel
          </Link>
          <button
            type="button"
            className="btn btn-primary"
            onClick={(...args) => props.changeTab(...args, "cibil")}
          >
            Next
          </button>
        </div>
      ) : (
        <div>
          {queryinfo
            .filter((q) => !q.responseId)
            .map((item) => (
              <>
                <div className="row">
                  <AppInput
                    name="uwDecision"
                    label="Underwriter Decision"
                    type="text"
                    defaultValue={item.uwDecision}
                    outerclass="col-12 col-md-3"
                    readOnly="true"
                  ></AppInput>

                  <AppInput
                    name="messageText"
                    label="Remarks"
                    readOnly="true"
                    defaultValue={item.messageText}
                    type="textarea"
                    outerclass="col-12 col-md-9 mb-3"
                  ></AppInput>
                </div>
              </>
            ))}
          <AppForm
            className="mx-auto"
            onSubmit={(...args) => handleDecision(...args)}
          >
            <AppInput
              name="uwDecision"
              label="Underwriter Decision"
              type="select"
              options={_enum.UNDER_WRITER_DECISION_DISCREPANCY}
              outerclass="col-12 col-md-3"
              required="true"
            ></AppInput>

            <AppInput
              name="messageText"
              label="Remarks"
              type="textarea"
              outerclass="col-12 col-md-9 mb-3"
            ></AppInput>
            <div className="nav_container mt-5">
              <Link
                to={`/app/loanapplications?activetab=${tabStatus}`}
                className="btn btn-primary-lite me-3"
              >
                Cancel
              </Link>
              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </div>
          </AppForm>
        </div>
      )}

      <IncomeDetailsModal
        id="employeeCanvas"
        ref={incomeDetailsForm}
        title={`${editmode
          ? `Edit ${infoModalType === "bankAccountModal"
            ? "Bank Account & Salary Credited Info."
            : infoModalType === "companyModal"
              ? "Salary Info."
              : ""
          }`
          : viewmode
            ? `View ${infoModalType === "cmAddress"
              ? "Bank Account & Salary Credited Info."
              : infoModalType === "bankAccountModal"
                ? "Salary Info."
                : ""
            }`
            : `Add ${infoModalType === "cmAddress"
              ? "Bank Account & Salary Credited Info."
              : infoModalType === "companyModal"
                ? "Salary Info."
                : ""
            }`
          }`}
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
        hasDynamicFields={infoModalType === "bankAccountModal" ? true : false}
        dynamicfields={salaryInfoFields}
        dynamicfieldid={"salaryCreditId"}
        dynamicdefaultdata={salaryCreditsData?.salaryData}
        handleDynamicFieldSubmit={(...args) => handleSalaryInfoSubmit(...args)}
        handleDynamicFieldUpdate={(...args) =>
          handleDynamicFieldUpdate(...args)
        }
        dynamicinputs={salaryInfoInputData}
        editdata={editData}
        fields={popupfields}
        editmode={editmode}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? "Update" : "Submit"}`}
        disableallfields={viewmode ? true : false}
        errorMessage={errorMessage}
      />

      <BankingConsentModal
        id="bankingConsentModal"
        title="Banking Consent"
        show={openBankingConsentModal}
        onClose={() => handleCloseBankingConsentModal()}
        data={popupBankingConsentData}
        editdata={editBankingConsentData}
        fields={popupBankingConsentFields}
        editmode={editBankingConsentmode}
        onSubmit={(...args) => handleBankingConsentSubmit(...args)}
        submitText={`${editBankingConsentmode ? "Update" : "Submit"}`}
        disableallfields={viewBankingConsentmode ? true : false}
      />

      <ReferrenceDetailsModal
        id="employeeCanvas"
        title={`${editmode
          ? "Edit Reference Detail"
          : viewmode
            ? "View Reference Detail"
            : "Add Reference Detail"
          }`}
        show={openRefCanvas}
        onClose={() => onRefModalClose()}
        data={popupRefdata}
        editdata={editRefData}
        fields={popupReffields}
        editmode={editRefmode}
        onSubmit={(...args) => handleRefSubmit(...args)}
        submitText={`${editRefmode ? "Update" : "Submit"}`}
        disableallfields={viewRefmode ? true : false}
      // errorMessage={errorMessage}
      />

      {/* PAYSLIP MODAL */}
      <Modal
        show={show}
        onHide={(...args) => handleClose(...args)}
        className="customer_application_modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Month {payslipfiles.length + 1} - Pay Slip</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <AppForm onSubmit={handlePayslipSubmit}>
            {payslipFields?.map((field, i) => (
              <AppInput {...field}></AppInput>
            ))}
            <Form.Check
              type="checkbox"
              id={`default-1`}
              label="File password protected"
              className="ms-3"
              onChange={(...args) => handlePasswordCheck(...args)}
            />
            {passcheck ? (
              <AppInput
                type="text"
                label="Password"
                name="filePassword"
              ></AppInput>
            ) : null}
            <Modal.Footer>
              <Button
                type="button"
                variant="secondary"
                onClick={(...args) => handleClose(...args)}
              >
                Cancel
              </Button>
              <Button type="submit" variant="primary">
                Upload
              </Button>
            </Modal.Footer>
          </AppForm>
        </Modal.Body>
      </Modal>

      {/* BANK-STATEMENT MODAL */}
      <Modal
        show={showbankmodal}
        onHide={(...args) => handleBSClose(...args)}
        className="customer_application_modal"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{activeBankStatement?.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <AppForm onSubmit={handleBankStatementSubmit}>
            {bankFields?.map((field, i) => (
              <AppInput {...field}></AppInput>
            ))}
            <Form.Check
              type="checkbox"
              id={`default-1`}
              label="File password protected"
              className="ms-3"
              onChange={(...args) => handleBSPasswordCheck(...args)}
            />
            {bankPassCheck ? (
              <AppInput
                type="text"
                label="Password"
                name="filePassword"
              ></AppInput>
            ) : null}
            <Modal.Footer>
              <Button
                type="button"
                variant="secondary"
                onClick={(...args) => handleBSClose(...args)}
              >
                Cancel
              </Button>
              <Button type="submit" variant="primary">
                Upload
              </Button>
            </Modal.Footer>
          </AppForm>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(IncomeDetails);
